import { ValidatorRules } from '../../../tradebuilder-v2/util/validator'
import { EditPortfoliosState } from '../edit-portfolio-slice'
import { isBalancedWeightTotal } from '../portfolio-weight'
import { getEffectivePortfolioOwnerId } from '../resolve-portfolio-owner'

export const editPortfolioRules: ValidatorRules<EditPortfoliosState> = {
  portfolio_name: [
    (state: EditPortfoliosState) => ({
      isValid: state.selectedPortfolio.portfolioName.length > 0,
      message: 'Portfolio must have a name'
    })
  ],
  portfolio_manager_checked: [
    (state: EditPortfoliosState) => {
      const {
        approvalByPM,
        user: { portfolioManagerCategory, roles }
      } = state

      const isPortfolioManager = roles.includes('PortfolioManager')

      const isValid =
        !isPortfolioManager ||
        (portfolioManagerCategory === 'Cat1' && approvalByPM) ||
        portfolioManagerCategory === 'Cat2'

      return {
        isValid,
        message: 'You must confirm approval'
      }
    }
  ],
  total_weights: [
    (state: EditPortfoliosState) => ({
      isValid: isBalancedWeightTotal(state.totalWeights),
      message: 'Asset weights must sum to 100%'
    })
  ],
  emptyAssetWeight: (state: EditPortfoliosState) => {
    const weights = state.selectedPortfolio.targetWeights.map(x => x.weight)
    return {
      isValid: !(weights.includes(null) || weights.includes(0)),
      message: 'Each asset must be assigned a weight'
    }
  },
  feeRates: (state: EditPortfoliosState) => {
    const fees = state.selectedPortfolio.fees.map(x => x.feeRate)
    return {
      isValid: !(fees.some(x => x <= 0) || fees.some(x => x > 0.2)),
      message: 'All fee rates must be greater than 0% and less than 20%'
    }
  },
  portfolio_owner: (state: EditPortfoliosState) => {
    const isFundOfFunds = state.selectedPortfolio.type === 'FundOfFunds'
    const portfolioOwnerId = getEffectivePortfolioOwnerId(
      state.selectedPortfolio as any,
      state.user
    )

    return {
      isValid: !isFundOfFunds || !!portfolioOwnerId,
      message: 'Portfolio owner is required for Fund of Funds'
    }
  }
}
